import { Request } from '../../../../../httpClient/serverApi/requests/Request';
import { ILanguage } from '../../../../../httpClient/serverApi/types/ILanguage';

export interface IGetLanguagesParams {
}

export interface IGetLanguagesResult {
  languages: ILanguage[];
}

export class GetLanguagesRequest extends Request<IGetLanguagesParams, IGetLanguagesResult> {
  constructor(params: IGetLanguagesParams = {}) {
    super('getLanguages', params);
  }
}
